module.exports = __webpack_public_path__ + "static/img-compostable-eb99e0d5b2312e35dc8b1d74a51d9839.jpg";